import React from "react";
import { Box, Typography } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import googleWorkSpace from "../../assets/logo/googleWorkspaceLogo.png";
import MicrosoftLogo from "../../assets/logo/Microsoft_365_logo.png";
import CompanySetupCard from "../../Components/CompanySetupCard/CompanySetupCard";

function WorkEmail({ onContinue, onBack }) {
  const handleOpenAccount = () => {
    console.log("handle handleOpenAccount clicked");
  };

  const emailProviders = [
    {
      id: "GoogleWorkspace",
      name: "Google Workspace",
      logo: googleWorkSpace,
      body: `Comprehensive suite of cloud-based productivity and
      collaboration tools—integrating email, document creation,
      storage, and real-time communication—designed to streamline
      workflow and enhance team efficiency from anywhere.`,
      buttonText: "Get started",
      applicationUrl: "https://workspace.google.com/intl/en_in/",
      offer: "",
    },
    {
      id: "Microsoft365",
      name: "Microsoft 365",
      logo: MicrosoftLogo,
      body: `Robust cloud-based suite of productivity and collaboration
      tools—featuring applications like Word, Excel, PowerPoint, and
      Teams—that streamline workflow, enhance communication, and
      boost productivity from virtually any device.`,
      buttonText: " Get started",
      applicationUrl: "https://www.microsoft.com/en-in/microsoft-365",
      offer: "",
    },
  ];

  return (
    <Box sx={{ p: 3, width: "100%", bgcolor: "#fff" }}>
      {/* Header Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      ></Box>

      {/* Description Text */}
      <Typography
        variant="body1"
        color="text.primary"
        sx={{ mb: 3, fontWeight: "450" }}
      >
        Whether you're team Google or team Microsoft, we've partnered with them
        both to get you the best
        <br /> available discounts - access them via links below :
      </Typography>
      {emailProviders.map((val) => (
        <CompanySetupCard
          id={val.id}
          logo={val.logo}
          title={val.name}
          offer={val.offer || ""}
          body={val.body}
          icon={LaunchIcon}
          buttonText={val.buttonText}
          applicationUrl={val.applicationUrl}
          handleOpenAccount={handleOpenAccount}
        />
      ))}
    </Box>
  );
}

export default WorkEmail;
